<!--
  The live content audit. Re-fetched every time the tab is opened, because a page or template batch created
  from here changes the answer — a cached gap list is a wrong gap list.
-->
<template>
  <div>
    <div class="d-flex align-center mb-3">
      <div class="text-caption grey--text">
        Audited {{ computedAt }}. Each fix runs in the background.
      </div>
      <v-spacer />
      <v-btn
        small
        icon
        title="Re-run the audit"
        :loading="loading"
        @click="reload"
      >
        <v-icon small>
          mdi-refresh
        </v-icon>
      </v-btn>
    </div>

    <NextStepList
      ref="list"
      :steps="items"
      :loading="loading"
      loading-text="Auditing this audience…"
      empty-text="No gaps — this audience has everything it needs."
      @run="runFix"
    />
  </div>
</template>

<script>
import NextStepList from '@/components/common/NextStepList';

export default {
  name: 'AudienceContentGaps',
  components: { NextStepList },
  props: {
    targetType: {
      type: Number,
      default: 0
    },
    targetId: {
      type: Number,
      default: 0
    },
    gaps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    items() {
      return this.gaps.items || [];
    },
    computedAt() {
      if (!this.gaps.computedDate) return 'just now';
      return new Date(this.gaps.computedDate).toLocaleTimeString();
    }
  },
  methods: {
    reload() {
      if (!this.targetId) return;
      this.loading = true;
      this.$store
        .dispatch('audiences/getGaps', { targetType: this.targetType, targetId: this.targetId })
        .catch((error) => this.logError(error))
        .finally(() => {
          this.loading = false;
        });
    },
    // NextStepList already handled "link" gaps and marked this one started; we only dispatch.
    runFix(gap) {
      this.$store
        .dispatch('audiences/runGapFix', {
          targetType: this.targetType,
          targetId: this.targetId,
          key: gap.key
        })
        .then(() => this.$root.$snackbarSuccess('Started — this runs in the background.'))
        .catch((error) => {
          this.$refs.list.unfire(gap.key);
          this.logError(error);
        });
    }
  }
};
</script>
